import React from 'react';
import { motion } from 'framer-motion';
const audiences = [{
  emoji: '👨‍👩‍👧',
  title: 'Parents',
  description: 'Turn everyday moments into emotional learning opportunities. Perfect for home use, car rides, and smoothing out bedtime routines.'
}, {
  emoji: '👩‍🏫',
  title: 'Teachers',
  description: 'Bring social-emotional learning into your classroom with ready-to-use activities that kids actually enjoy and ask for.'
}, {
  emoji: '🧑‍⚕️',
  title: 'Therapists',
  description: 'A versatile therapeutic tool for sessions. Engaging materials that make emotional exploration feel safe, structured, and fun.'
}];
export function WhoItsFor() {
  return <section className="py-24 bg-mint relative" data-id="element-300">
      {/* Top Wave Divider */}
      <div className="absolute top-0 left-0 w-full overflow-hidden leading-none -translate-y-[99%] z-10" data-id="element-301">
        <svg className="relative block w-full h-[40px] sm:h-[60px]" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none" data-id="element-302">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" className="fill-mint" data-id="element-303"></path>
        </svg>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-304">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center max-w-3xl mx-auto mb-16" data-id="element-305">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-dark mb-6 text-balance" data-id="element-306">
            Designed For Anyone Who Cares About a Child's Emotional Growth
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-307">
          {audiences.map((audience, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.15
        }} className="bg-white rounded-3xl p-8 shadow-sm hover:shadow-md transition-shadow" data-id="element-308">
              <div className="text-5xl mb-6 bg-mint w-20 h-20 rounded-2xl flex items-center justify-center" data-id="element-309">
                {audience.emoji}
              </div>
              <h3 className="text-2xl font-heading font-bold text-dark mb-4" data-id="element-310">
                {audience.title}
              </h3>
              <p className="text-muted leading-relaxed text-lg" data-id="element-311">
                {audience.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}